import State from './state'
import { createSlice } from '@reduxjs/toolkit'

const patientsReducer = createSlice({
  name: 'patientsReducer',
  initialState: State,
  reducers: {
    setRecords: (state, action) => {
      state.data = action.payload
    }
  }
})

export default patientsReducer
